import { IStoreProps } from '../index';
import { useDispatch } from 'react-redux';
import React, { useEffect } from 'react';
import { getNotificationsData } from '../data/data-service';
import Preloader from '../../../../ui/svg/common/preloader';
import NotificationsList from './notifications-list';
import NoNotifications from './no-notifications';

interface INotificationsPanelProps {
    storeProps: IStoreProps;
    isMobile: boolean;
}

const NotificationsPanel = ({ storeProps, isMobile }: INotificationsPanelProps) => {

    const { useAppSelector, rootActions } = storeProps;

    const dispatch = useDispatch();

    const isLoading = useAppSelector(store => store.root.isLoading);
    const notifications = useAppSelector(store => store.root.notifications);

    useEffect(() => {

            (async () => {
                dispatch(
                    rootActions.main({
                        isLoading: true,
                    })
                );

                const response = await getNotificationsData();

                dispatch(
                    rootActions.main({
                        isLoading: false,
                    })
                );

                if(!response || response.statusCode !== 200) return;

                const count = response.data?.count || 0;
                const notifications = response.data?.notifications || [];

                dispatch(
                    rootActions.main({
                        count,
                        notifications,
                    })
                );
            })();
        },

        [dispatch, rootActions]);

    const onClick = () => {
        dispatch(
            rootActions.main({
                additionalOpenedMenuNotification: null,
                additionalOpenedMenuStyles: null,
            })
        );
    };

    return (
        <div
            onClick={ onClick }
            className={`top-notifications-drop absolute right-0 top-full bg-white text-gray-500 shadow-md rounded py-4 px-2 text-tiny border border-gray-100 ${ isMobile ? 'left-0 w-screen top-notifications-drop-m' : '' }`}
            style={{
                maxWidth: isMobile ? '450px' : 'calc(100vw - 8px)',
            }}>

            {
                isLoading &&
                <div className="flex justify-center my-8">
                    <Preloader width="25px" height="25px" color="#4f4f4f" />
                </div>
            }

            {
                !isLoading &&
                (
                    <>
                        {
                            notifications.length <= 0 &&
                            <NoNotifications />
                        }

                        {
                            notifications.length > 0 &&
                            <NotificationsList storeProps={ storeProps } />
                        }
                    </>
                )
            }

        </div>
    )
};

export default NotificationsPanel;